import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@ui/dialog';
import { Button } from '@shared/components/ui/button';

type TimeoutType = 'payment';

interface TimeoutModalProps {
  open: boolean;
  type: TimeoutType;
  onConfirm: () => void;
}

const TIMEOUT_CONTENT: Record<
  TimeoutType,
  {
    title: string;
    description: string;
  }
> = {
  payment: {
    title: 'Время оплаты истекло',
    description: 'К сожалению, время на оплату истекло. Заказ был отменен.',
  },
};

/**
 * Универсальный компонент модального окна для уведомления об истечении времени оплаты
 */
export const TimeoutModal = ({ open, type, onConfirm }: TimeoutModalProps) => {
  const content = TIMEOUT_CONTENT[type];

  const handleClose = () => {
    onConfirm();
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent
        onPointerDownOutside={e => e.preventDefault()}
        onEscapeKeyDown={e => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{content.title}</DialogTitle>
          <DialogDescription>{content.description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            className="cursor-pointer bg-action-primary text-action-primary-foreground hover:bg-action-primary-hover"
            onClick={handleClose}
          >
            Понятно
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
